module.exports = __webpack_public_path__ + "assets/img/testi4.62af7d64.jpg";